<section class="vc-admin-contact-leads">
  <header class="vc-admin-contact-leads__hero">
    <div>
      <p class="vc-admin-contact-leads__eyebrow">
        {{ 'ADMIN.CONTACT_LEADS.EYEBROW' | translate }}
      </p>
      <h2>{{ 'ADMIN.CONTACT_LEADS.TITLE' | translate }}</h2>
      <p>{{ 'ADMIN.CONTACT_LEADS.DESCRIPTION' | translate }}</p>
    </div>

    <div class="vc-admin-contact-leads__metric" aria-live="polite">
      <span>{{ pending }}</span>
      <small>{{ 'ADMIN.CONTACT_LEADS.PENDING' | translate }}</small>
    </div>
  </header>

  <section
    class="vc-admin-contact-leads__toolbar"
    [attr.aria-label]="'ADMIN.CONTACT_LEADS.FILTERS_ARIA' | translate"
  >
    <label class="vc-admin-contact-leads__field">
      <span>{{ 'ADMIN.CONTACT_LEADS.SEARCH' | translate }}</span>
      <input
        pInputText
        type="search"
        [(ngModel)]="q"
        [placeholder]="'ADMIN.CONTACT_LEADS.SEARCH_PLACEHOLDER' | translate"
        (keyup.enter)="applyFilters()"
      />
    </label>

    <label class="vc-admin-contact-leads__field">
      <span>{{ 'ADMIN.CONTACT_LEADS.STATUS_FILTER' | translate }}</span>
      <select [(ngModel)]="status" (change)="applyFilters()">
        <option value="ALL">{{ 'ADMIN.CONTACT_LEADS.ALL_STATUSES' | translate }}</option>
        @for (option of statusOptions; track option.value) {
          <option [value]="option.value">{{ option.labelKey | translate }}</option>
        }
      </select>
    </label>

    <div class="vc-admin-contact-leads__toolbar-actions">
      <button pButton type="button" icon="pi pi-search" (click)="applyFilters()">
        {{ 'COMMON.SEARCH' | translate }}
      </button>
      <button pButton type="button" severity="secondary" (click)="clearFilters()">
        {{ 'COMMON.CLEAR' | translate }}
      </button>
      <button
        pButton
        type="button"
        severity="secondary"
        icon="pi pi-refresh"
        (click)="load()"
        [disabled]="loading"
      >
        {{ 'ADMIN.CONTACT_LEADS.REFRESH' | translate }}
      </button>
    </div>
  </section>

  @if (loading) {
    <p class="vc-admin-contact-leads__state">{{ 'COMMON.LOADING' | translate }}</p>
  } @else if (!rows.length) {
    <section class="vc-admin-contact-leads__empty">
      <h3>{{ 'ADMIN.CONTACT_LEADS.EMPTY_TITLE' | translate }}</h3>
      <p>{{ 'ADMIN.CONTACT_LEADS.EMPTY_DESCRIPTION' | translate }}</p>
    </section>
  } @else {
    <p-table [value]="rows" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'ADMIN.CONTACT_LEADS.CREATED_AT' | translate }}</th>
          <th>{{ 'ADMIN.CONTACT_LEADS.PERSON' | translate }}</th>
          <th>{{ 'ADMIN.CONTACT_LEADS.CONTACT' | translate }}</th>
          <th>{{ 'ADMIN.CONTACT_LEADS.MESSAGE' | translate }}</th>
          <th>{{ 'ADMIN.CONTACT_LEADS.SOURCE' | translate }}</th>
          <th>{{ 'ADMIN.CONTACT_LEADS.STATUS' | translate }}</th>
          <th>{{ 'ADMIN.CONTACT_LEADS.NOTES' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td class="vc-admin-contact-leads__date">
            <strong>{{ row.created_at | date: 'dd/MM/yyyy' }}</strong>
            <span>{{ row.created_at | date: 'HH:mm' }}</span>
          </td>
          <td>
            <div class="vc-admin-contact-leads__person">
              <strong>{{ row.name }}</strong>
              <span>{{ row.clinic_name }}</span>
            </div>
          </td>
          <td>
            <div class="vc-admin-contact-leads__contact">
              <a [href]="'mailto:' + row.email">{{ row.email }}</a>
              <a [href]="'tel:' + row.phone">{{ row.phone }}</a>
            </div>
          </td>
          <td>
            <p class="vc-admin-contact-leads__message">{{ row.message }}</p>
          </td>
          <td>
            <div class="vc-admin-contact-leads__source">
              <span>{{ displaySource(row) }}</span>
              <small>{{ displayLocale(row) }}</small>
              @if (row.plan_id) {
                <small>{{ 'ADMIN.CONTACT_LEADS.PLAN' | translate }}: {{ row.plan_id }}</small>
              }
            </div>
          </td>
          <td>
            <span
              class="vc-admin-contact-leads__status"
              [ngClass]="statusClass(row.status)"
            >
              {{ statusLabel(row.status) }}
            </span>
            <select [(ngModel)]="row._draftStatus">
              @for (option of statusOptions; track option.value) {
                <option [value]="option.value">{{ option.labelKey | translate }}</option>
              }
            </select>
          </td>
          <td>
            <textarea
              [(ngModel)]="row._draftNotes"
              [placeholder]="'ADMIN.CONTACT_LEADS.NOTES_PLACEHOLDER' | translate"
              rows="4"
            ></textarea>
          </td>
          <td>
            <button
              pButton
              type="button"
              size="small"
              icon="pi pi-check"
              (click)="save(row)"
              [disabled]="row._saving"
            >
              {{ 'COMMON.SAVE' | translate }}
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <footer class="vc-admin-contact-leads__pagination">
      <span>
        {{ rangeLabel }} / {{ total }}
      </span>
      <div>
        <button
          pButton
          type="button"
          size="small"
          severity="secondary"
          (click)="previousPage()"
          [disabled]="page <= 0"
        >
          {{ 'ADMIN.CONTACT_LEADS.PREVIOUS' | translate }}
        </button>
        <button
          pButton
          type="button"
          size="small"
          severity="secondary"
          (click)="nextPage()"
          [disabled]="!canGoNext"
        >
          {{ 'ADMIN.CONTACT_LEADS.NEXT' | translate }}
        </button>
      </div>
    </footer>
  }
</section>
